// extracted by mini-css-extract-plugin
export default {"container":"ShareLinkInput_container__LjhUs","button":"ShareLinkInput_button__30KjB","inputGroupText":"ShareLinkInput_inputGroupText__NgtIp"};